import { useState, useEffect } from 'react';
import {
  getProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  updateDescriptionProduct,
  getProductById,
  findOneCategoriesProductByidProduct,
  getMasterProducts,
  updateActive
} from '../services/ProductService';
import useAlert from '../../../shared/hooks/useAlert';

export const useProducts = () => {

  const [categoriesProduct, setCategoriesProduct] = useState([]);
  const [products, setProducts] = useState([]);
  const [masterproducts, setMasterProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { alert, showAlert } = useAlert();

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await getProducts();
      setProducts(response.data);

      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }

    setLoading(false);
  };

  const fetchMasterProducts = async () => {
    setLoading(true);
    try {
      const response = await getMasterProducts();
      console.log('ini response master product ', response?.data)
      setMasterProducts(response.data);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  const fetchProductsById = async (id) => {
    setLoading(true);
    try {
      const response = await getProductById(id);
      setProducts(response.data);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  const findOneCategoriesProductByid = async (id) => {
    setLoading(true);
    try {
      const response = await findOneCategoriesProductByidProduct(id);
      setCategoriesProduct(response.data);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  const addProduct = async (product) => {

    try {
      const response = await createProduct(product);
      setProducts([...products, response.data]);
      showAlert('Created successfully!', 'success');
    } catch {
      setError('Failed to add product');
      showAlert('Error creating', 'danger');
    }
  };

  const editProduct = async (id, updatedProduct) => {
    try {
      const response = await updateProduct(id, updatedProduct);
      setProducts(products.map(p => (p.id === id ? response.data : p)));
      showAlert('Created successfully!', 'success');
    } catch {
      setError('Failed to update product');
      showAlert('Error creating', 'danger');
    }
  };

  const editDescriptionProduct = async (id, updatedProduct) => {
    try {
      const response = await updateDescriptionProduct(id, updatedProduct);
      setProducts(products.map(p => (p.id === id ? response.data : p)));
    } catch {
      setError('Failed to update product');
    }
  };

  const removeProduct = async (id) => {
    try {
      await deleteProduct(id);
      setProducts(products.filter(p => p.id !== id));
    } catch {
      setError('Failed to delete product');
    }
  };


  const updateOnActive = async (id, updatedStatus) => {
    try {
      const response = await updateActive(id, updatedStatus);
      setProducts(products.map(p => (p.id === id ? response.data : p)));
      showAlert('Edited successfully!', 'success');
    } catch {
      setError('Failed to update categories');
      showAlert('Error creating', 'danger');
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchMasterProducts();
  }, []);

  return {
    masterproducts,
    categoriesProduct,
    products,
    loading,
    error,
    alert,
    fetchMasterProducts,
    findOneCategoriesProductByid,
    fetchProductsById,
    addProduct,
    editProduct,
    removeProduct,
    editDescriptionProduct,
    fetchProducts,
    updateOnActive
  };

};
